import { defineComponent as _defineComponent } from 'vue'
import UnAuthPage from "@/components/layout/UnAuthPage.vue"
import { ref, onMounted } from "vue"
import { useMutation } from "@/hooks/useMutation"
import {
  ConfirmEmailMutation,
  ConfirmEmailMutationMutation,
  ConfirmEmailMutationMutationVariables,
} from "@/gql"
import useRouter from "@/router/useRouter"


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmEmail',
  setup(__props) {

const loading = ref(true)
const unverified = ref(false)
const { mutate } = useMutation()

onMounted(async () => {
  const token = new URLSearchParams(location.search).get("token")
  const { router, routes } = useRouter()

  const result = await mutate<ConfirmEmailMutationMutation, ConfirmEmailMutationMutationVariables>({
    mutation: ConfirmEmailMutation,
    variables: {
      confirmationToken: token!,
    },
  })
  if (result?.data?.confirmEmail) {
    const response = result.data.confirmEmail.response
    if (response?.success) {
      router.push({
        name: routes.Home,
      })
    } else {
      loading.value = false
      unverified.value = true
    }
  }
})

return { __sfc: true,loading, unverified, mutate, UnAuthPage }
}

})